import { apiRequest } from "../../util/apiUtils";

export const getChart = async (params) => {
  try {
    const res = await apiRequest("get", `/chart`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};



export const chartAdd = async (payload) => {
  try {
    const res = await apiRequest("post", `/chart/add`, {
      body: payload,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
export const chartMidLevelAdd = async (payload) => {
  try {
    const res = await apiRequest("post", `/chart/mid-level-add`, {
      body: payload,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const chartDetails = async (params) => {
  try {
    const res = await apiRequest("get", `/chart/${params?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const chartEdit = async ({ id, payload }) => {
  try {
    const res = await apiRequest(
      "put",
      `/chart/${id}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const deleteChart = async ({ id, payload }) => {
  try {
    const res = await apiRequest("patch", `/chart/remove/${id}`, {
      body: payload,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const unAssignUser = async ({ id }) => {
  try {
    const res = await apiRequest("patch", `/chart/remove-user/${id}`, {
      body: {},
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const getExcelData = async (params) => {
  try {
    const res = await apiRequest("GET", `/sheet/export-all-dummy`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
export const csvUploadChart = async (payload = {}) => {
  try {
    const res = await apiRequest(
      "post",
      `/sheet/up-employee-chart-dummy`,
      {
        body: payload,
      },
      "multipart/form-data"
    );
    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const getshareLink = async () => {
  try {
    const res = await apiRequest("GET", `/social/fetch-link`);
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const getChartShare = async (params) => {
  try {
    const res = await apiRequest("GET", `/social/detail/${params}`);
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const chartDragAndDrop = async (payload) => {
  // "chnage api end point:/chart/card/move "
  try {
    const res = await apiRequest("patch", `/chart/card/move-new`, {
      body: payload,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

//////////////////////////////////////// For Research

export const chartDetailsResearch = async (params) => {
  try {
    const res = await apiRequest("get", `/chart/details/${params?.id}`);

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const chartEditResearch = async ({ id, payload }) => {
  try {
    const res = await apiRequest(
      "put",
      `/chart/new-edit/${id}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );
    return res?.data;
  } catch (error) {
    return error;
  }
};
export const deleteChartResearch = async ({ id, payload }) => {
  try {
    const res = await apiRequest("patch", `/chart/remove-new/${id}`, {
      body: payload,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const unAssignUserResearch = async ({ id }) => {
  try {
    const res = await apiRequest("patch", `/chart/remove-user-new/${id}`, {
      body: {},
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const csvUploadChartResearch = async (payload = {}) => {
  try {
    const res = await apiRequest(
      "post",
      `/sheet/up-employee-chart-dummy-new`,
      {
        body: payload,
      },
      "multipart/form-data"
    );
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const getChartNew = async (params) => {
  try {
    const res = await apiRequest("get", `/chart/list-new`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};

export const getLinearChart = async (params) => {
  try {
    const res = await apiRequest("get", `/chart-linear/linear-list`, {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};